<template>
    <div class="e2e-html">
        <div ref="htmlContent" v-html="fragment.html"/>
    </div>
</template>

<script>
import { postProcessDom } from "../layout-bom";

/**
 * fragment.html = HTML-Text
 */
export default {
  name: "fragment-html",
  props: ["fragment"],
  updated() {
    postProcessDom(this.$refs.htmlContent);
  },
  mounted() {
    postProcessDom(this.$refs.htmlContent);
  }
};
</script>
 

<style scoped>
</style>